const chartColors = {
  red: {
    transparency: 'rgb(255, 99, 132, 0.5)',
    border: 'rgb(255, 99, 132)',
    background: 'rgb(255, 99, 132)',
  },
  orange: {
    transparency: 'rgb(255, 159, 64, 0.5)',
    border: 'rgb(255, 159, 64)',
    background: 'rgb(255, 159, 64)',
  },
  yellow: {
    transparency: 'rgb(255, 205, 86, 0.5)',
    border: 'rgb(255, 205, 86)',
    background: 'rgb(255, 205, 86)',
  },
  green: {
    transparency: 'rgb(75, 192, 192, 0.5)',
    border: 'rgb(75, 192, 192)',
    background: 'rgb(75, 192, 192)',
  },
  blue: {
    transparency: 'rgb(54, 162, 235, 0.5)',
    border: 'rgb(54, 162, 235)',
    background: 'rgb(54, 162, 235)',
  },
  purple: {
    transparency: 'rgb(153, 102, 255, 0.5)',
    border: 'rgb(153, 102, 255)',
    background: 'rgb(153, 102, 255)',
  },
  grey: {
    transparency: 'rgb(201, 203, 207, 0.5)',
    border: 'rgb(201, 203, 207)',
    background: 'rgb(201, 203, 207)',
  },
};

export default chartColors;
